import { NetworkMap } from "../components/NetworkMap";
import { SectionHeader } from "../components/SectionHeader";
import { StatusPill } from "../components/StatusPill";
import { fetchDashboardCopyNetwork } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

export function CopyNetworkPage() {
  const state = useDashboardQuery(fetchDashboardCopyNetwork);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Copy network</h1>
          <p>Leader → follower relationships for this tenant. No live trade payloads.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No copy relationships"
        emptyDetail="This tenant has no registered leader–follower relationships yet."
      >
        {(data) => (
          <div className="panel">
            <SectionHeader
              title="Relationship map"
              subtitle={`${data.edges.length} edge${data.edges.length === 1 ? "" : "s"}`}
            />
            <div className="panel-body">
              {data.edges.length === 0 ? null : (
                <NetworkMap
                  rows={Object.values(
                    data.edges.reduce<
                      Record<string, { leader: string; followers: { name: string; status: string }[] }>
                    >((acc, edge) => {
                      const key = edge.leaderLabel;
                      if (!acc[key]) acc[key] = { leader: key, followers: [] };
                      acc[key].followers.push({
                        name: edge.followerLabel,
                        status: edge.status,
                      });
                      return acc;
                    }, {})
                  )}
                />
              )}
            </div>
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
